"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareQueryGetRecoveryInRange = void 0;
const prepareQueryGetRecoveryInRange = ({ userId, from, to, }) => `
  query recoveryProgressFor {
      progressCollection(userId: ${userId}, range: {
        from: "${from}",
        to: "${to}"
      }) {
        id
        dayType     
        day
        date
        motivation
        motivationReason
        sleepHours
        sleepStart
        sleepEnd
        sleepQuality
        heartRate
        muscleStrain: muscleStiffness
        stressLevel
    
        muscleStiffnessAlert
        sleepQualityAlert
        sleepHoursAlert
        heartRateAlert
        stressLevelAlert
        
        trained
        didLesson
        drankWater
        supplemented
        ateAsRecommended
        ateAsRecommendedPercentage
        
        missedTrainingReason
        missedLessonReason
      }
    }
`;
exports.prepareQueryGetRecoveryInRange = prepareQueryGetRecoveryInRange;
//# sourceMappingURL=getRecoveryRange.js.map